import {useEffect, useRef} from 'react';

const events = [
    "load",
    "mousemove",
    "mousedown",
    "click",
    "scroll",
    "keypress",
];

export const useSessionTimeout = (timeoutSeconds: number, logoutCallback: () => void) => {
    const timerRef = useRef<NodeJS.Timeout>();

    useEffect(() => {
        const resetTimer = () => {
            if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(logoutCallback, timeoutSeconds * 1000);
        };

        const handleTimer = () => {
            resetTimer();
            events.forEach((eventName) => {
                window.addEventListener(eventName, resetTimer);
            });
        };

        handleTimer();

        return () => {
            events.forEach((eventName) => {
                window.removeEventListener(eventName, resetTimer);
            });
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [timeoutSeconds, logoutCallback]);
};
